export default __webpack_public_path__ + "static/media/medical2.1724613c.png";